export const attachableLinkUrl = '/attachable-link';
export const feedPageUrl = '/feed';
export const storylinesPageUrl = '/storylines';
export const usagePolicyUrl = '/usage-policy';

/**
 * @deprecated: YamJS is being deprecated. Do not use this code.
 */
export const createGroupUrl = '/create-group';
export const userSettingsUrl = '/user-settings/general';
export const delegationSettingsUrl = '/user-settings/delegates';
export const userNotificationSettingsUrl = '/user-settings/notifications';
export const adminCenterUrl = '/admin';
/**
 * @deprecated: YamJS is being deprecated. Do not use this code.
 */
export const networkAdminSettingsUrl = '/network-admin';
export const storylineAdminSettingsUrl = '/admin/settings/storyline';
/**
 * @deprecated: YamJS is being deprecated. Do not use this code.
 */
export const storylineAdminNotificationSettingsUrl = '/admin/settings/storyline/notifications';
export const storylineAdminAdvancedSettingsUrl = '/admin/settings/storyline/advanced';
export const m365CopilotAdoptionPageUrl = '/admin/m365-copilot-adoption';
export const rootPageUrl = '/';
